import { render, staticRenderFns } from "./OverseasLogistics.vue?vue&type=template&id=de9232d0&scoped=true"
import script from "./OverseasLogistics.vue?vue&type=script&lang=js"
export * from "./OverseasLogistics.vue?vue&type=script&lang=js"
import style0 from "./OverseasLogistics.vue?vue&type=style&index=0&id=de9232d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de9232d0",
  null
  
)

export default component.exports